/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;z-index:100}.splt-vertical[_nghost-%COMP%]{position:absolute;z-index:100;top:0;bottom:0;width:4px;cursor:col-resize}.splt-horizontal[_nghost-%COMP%]{position:absolute;z-index:100;left:0;right:0;height:4px;cursor:row-resize}.splt-edge-left[_nghost-%COMP%]{position:absolute;z-index:100;left:0}.splt-edge-right[_nghost-%COMP%]{position:absolute;z-index:100;right:0}.splt-edge-top[_nghost-%COMP%]{position:absolute;z-index:100;top:0}"];
export { styles as styles };
